<template>
  <div class="footer-container">
    <div class="first-line">
      <span class="first-line-span">网络文化许可证-京网文-（2021）1897-496号</span>
      <span>经营许可证编号：京B2-20181623</span>
    </div>
    <div class="second-line">
      <span>互联网药品信息服务证资格证编号：(京)-经营性-2020-0032</span>
      <a
        v-for="content in contents"
        :key="content.name"
        :href="content.link"
        target="_blank"
      >
        {{ content.name}}
      </a>
    </div>
    <div class="second-line">
      <a href="https://beian.miit.gov.cn/" target="_blank">©&nbsp;{{ currentYear }}&nbsp;巨量引擎 京ICP备17021358号-2</a>
      <a
        v-for="content in contentsLink"
        :key="content.name"
        :href="content.link"
        target="_blank"
      >
        {{ content.name}}
      </a>
      <span>北京巨量引擎网络技术有限公司</span>
    </div>
    <div class="last-line">
      <img src="../../../static/images/jinggongwang.png" class="last-line-img"/>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802029672" target="_blank">
        京公网安备 11010802029672号
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
  // @import './new-footer.scss'
  .footer-container {
    width: 100%;
    min-width: 800px;
    text-align: center;
    padding: 22px 0;
    background: #0A2140;
    // font-size: 0;
    position: relative;
    font-family: 'PingFang SC';
    font-weight: 600;
    .first-line {
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      font-weight: 600;
      opacity: 0.4;
      color: #FFFFFF;
      .first-line-span {
        margin-right: 10px;
      }
    }
    .second-line {
      margin-top: 8px;
      span, a {
        font-size: 12px;
        color: #FFFFFF;
        opacity: 0.4;
        margin-right: 10px;
        font-weight: 600;
      }
    }
    .last-line{
      margin-top: 8px;
      text-align: center;
      a {
        font-size: 12px;
        color: #FFFFFF;
        opacity: 0.4;
        margin-right: 10px;
        font-weight: 600;
        // font-family: 'PingFang SC';
        text-align: center;
        line-height: 20px;
      }
      .last-line-img {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }
    }
    a {
        text-decoration: none;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
  }
</style>

<script>
  export default {
    name:"new-footer",
    data () {
      return {
        contents: [{
          name: '网络文化经营许可证',
          link: 'https://www.oceanengine.com/extra/icp-wenhua'
        }, {
          name: '增值电信业务经营许可证',
          link: 'https://www.oceanengine.com/extra/license-jingying'
        }, {
          name: '互联网宗教信息服务许可证',
          link: 'https://www.oceanengine.com/extra/license-zongjiao'
        }],
        contentsLink: [{
          name: '隐私政策',
          link: 'https://lf6-cdn-tos.bytescm.com/obj/ies-hotsoon-draft/account_center/e912e0b7-40d8-44f6-acfb-312f327d7685.html'
        }, {
          name: '营业执照',
          link: 'https://www.oceanengine.com/license'
        }],
        currentYear: new Date().getFullYear()
      }
    }
  }
</script>
